(function () {
	'use strict';

    //polyfills the closest function to find the next closest parent of a specific selector
    if (!Element.prototype.closest) {
        Element.prototype.closest = 
        function(s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                i,
                el = this;
            do {
                i = matches.length;
                while (--i >= 0 && matches.item(i) !== el) { return;}
            } while ((i < 0) && (el = el.parentElement)); 
            return el;
        };
    }
	
})();


//////////////////
// WEBPACK FOOTER
// ./src/sharebase-app/polyfills/closest.js
// module id = 1324
// module chunks = 0